import { render, staticRenderFns } from "./sidbar-admin.vue?vue&type=template&id=2bc5f0ab&scoped=true"
import script from "./sidbar-admin.vue?vue&type=script&lang=js"
export * from "./sidbar-admin.vue?vue&type=script&lang=js"
import style0 from "./sidbar-admin.vue?vue&type=style&index=0&id=2bc5f0ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc5f0ab",
  null
  
)

export default component.exports